import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActionTypes } from '@rd/core/auth/store/actions/auth.actions';
import { Enrollment, HttpError } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { EnrollmentApiService } from '../../services/enrollment-api/enrollment-api.service';
import * as actions from '../actions/enrollment.actions';

@Injectable()
export class EnrollmentEffects {
  constructor(
    private actions$: Actions,
    private enrollmentApiService: EnrollmentApiService,
  ) {}

  loadEnrollments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.EnrollmentActionTypes.LOAD_ENROLLMENTS),
      switchMap(() => {
        return this.enrollmentApiService.getEnrollments().pipe(
          map((enrollments: Enrollment[]) => {
            return new actions.LoadEnrollmentsSuccess(enrollments);
          }),
          catchError((error: HttpError) =>
            of(new actions.LoadEnrollmentsFail(error)),
          ),
        );
      }),
    ),
  );

  pullEnrollmentsOnUserLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActionTypes.LOGIN_USER),
      take(1),
      map(() => {
        return new actions.LoadEnrollments();
      }),
    ),
  );
}
